import "../promotersPages.scss";
import { iconsImgs } from "../../../utils/icons";
import Gender from "../../../api/enums/Gender";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { routes } from "../../../routes/routes";
import { SelectedGroupContext } from "../../../GlobalContext/groupDetailContext";
import { DateFormat, formatDate } from "../../../utils/datePareser";
import { getUserAvatar } from "../../../utils/getMedia";
import OpenClubsForPromoterGroupApi from "../../../api/OpenClubsForPromoterGroupApi";
import { ApiResponse } from "../../../api/responses/AxiosResponseHandler";
import { PromoterGroupOpenClubsApiResponse } from "../../../api/responses/PromoterGroupOpenClubsApiResponse";
import { parseOpenClubsResponse } from "../../../api/parseResponse/parsePromoterGroupOpenClubsResponse";
import { OpenClubsContext } from "../../../GlobalContext/openClubsContext";
import { PartyModel } from "../../../types";
import { filterGroupsByMinimumAge } from "../../../utils/utils";
import AuthClient from "../../../api/AuthClient";
import RefreshButton from "../../RefreshToUpdateData/RefreshToUpdateButton";
import { PromoterGroupsContext } from "../../../GlobalContext/promoterGroupsContext";
import handleImgError from "../../../handleImgError";

const Seen: React.FC = () => {
    const authClient = new AuthClient();
    const currentCity = authClient.getAuthenticationResponse()?.cityName;
    const { setSelectedGroup } = useContext(SelectedGroupContext);
    const { setPromoterGroupOpenClubs } = useContext(OpenClubsContext);
    const { groups, requestState, fetchGroups, seenGroupIds } = useContext(PromoterGroupsContext);

  const [scrollPosition, setScrollPosition] = useState(0);
  const [minimumAge, setMinimumAge] = useState<number | "">("");
  const minimumAgeOptions = Array.from({ length: 8 }, (_, index) => 18 + index);

  const seenIdSet = new Set(seenGroupIds.map((s) => s.id));
  const filteredGroupsBySeen: PartyModel[] = groups.filter((g) => seenIdSet.has(g.party.id));
  const hasActiveMinimumAgeFilter = minimumAge !== "";

  const filteredGroups: PartyModel[] = filterGroupsByMinimumAge(filteredGroupsBySeen, minimumAge);

  const handleClickInvitation = (groupInvitation: PartyModel) => {
    const selectedGroup = filteredGroups.find(
      (group) => group.party.id === groupInvitation.party.id
    );

        if (selectedGroup) {
            setSelectedGroup(selectedGroup);

            const openClubsAPI = new OpenClubsForPromoterGroupApi(authClient);
            openClubsAPI.getPromoterGroupOpenClubs(selectedGroup.party.city, selectedGroup.party.partyDate, selectedGroup.party.bookingType.toString(), selectedGroup.promotersOffers[0]?.promoter?.id).then((clubs) => {
                const response: ApiResponse<PromoterGroupOpenClubsApiResponse> | undefined = clubs;
                const parsedOpenClubs = parseOpenClubsResponse(response?.data?.openClubs);
                if (parsedOpenClubs.openClubs) {
                    setPromoterGroupOpenClubs(parsedOpenClubs.openClubs);
                }
            });
        }
    };

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const { scrollLeft } = event.currentTarget;
        setScrollPosition(scrollLeft);
    };

    const handleDragStart = (
        event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
    ) => {
        event.preventDefault();
        const startX =
            "touches" in event ? event.touches[0].clientX : event.clientX;

        const handleDragMove = (event: MouseEvent | TouchEvent) => {
            event.preventDefault();
            const currentX =
                "touches" in event ? event.touches[0].clientX : event.clientX;
            const deltaX = startX - currentX;

            const scrollContainer = event.currentTarget as HTMLDivElement;
            scrollContainer.scrollLeft = scrollPosition + deltaX;
        };

        const handleDragEnd = () => {
            document.removeEventListener("mousemove", handleDragMove);
            document.removeEventListener("touchmove", handleDragMove);
            document.removeEventListener("mouseup", handleDragEnd);
            document.removeEventListener("touchend", handleDragEnd);
        };

        document.addEventListener("mousemove", handleDragMove);
        document.addEventListener("touchmove", handleDragMove);
        document.addEventListener("mouseup", handleDragEnd);
        document.addEventListener("touchend", handleDragEnd);
    };

    const formattedDate = (inputDateString: Date, inCludeTime: boolean) => {
        const date = new Date(inputDateString);
        return formatDate(date, inCludeTime, DateFormat.Short);
    }

    const handleRefreshClick = () => {
        fetchGroups();
    };

  return (
    <>
      <div className="input-group mb-3 ageInputContainer ">
        <select
          className="form-control shadow-none ageInput"
          aria-label="Minimum Age"
          aria-describedby="basic-addon1"
          value={minimumAge}
          onChange={(event) => {
            const value = event.target.value === "" ? "" : Number(event.target.value);
            setMinimumAge(value);
          }}
        >
          <option value="">Minimum age (any)</option>
          {minimumAgeOptions.map((age) => (
            <option key={age} value={age}>
              {age}
            </option>
          ))}
        </select>
      </div>
      <div className="mb-3 refreshRequestContainer">
        <RefreshButton requestState={requestState} onClickHandler={handleRefreshClick} />
      </div>
      {filteredGroups.length > 0 ? (
        <div>
          {filteredGroups.map((group) => (
            <div className="groupPromoter" key={group.party.id}>
              <div className="datePm d-flex align-items-center w-100">
                <p> {formattedDate(group.party.partyDate, false)} </p>
              </div>
              <div className=" text-center row align-items-start">
                <div className="guestListTitle greyBorder col">
                  <p className="mt-2">{group.party.bookingType}</p>
                </div>
                <div className="yellowTxt greyBorder align-content-center justify-content-center  d-flex col">
                  <p className="mt-3 mb-2">
                    {
                      group.invitations.filter(
                        (invitation) => (Gender[invitation.gender]).toString() === Gender.Female.toString()
                      ).length
                    }
                  </p>
                  <img src={iconsImgs.Female} alt="" className="mt-3 Icons" />
                  <p className="mt-3 mb-2 ">
                    {
                      group.invitations.filter(
                        (invitation) => (Gender[invitation.gender]).toString() === Gender.Male.toString()
                      ).length
                    }
                  </p>
                  <img src={iconsImgs.Male} alt="" className="mt-3 Icons" />
                </div>
                <div className="dateCreated createdAt greyBorder d-flex flex-column col">
                  <p>Created</p>
                  <p className="createdAt">
                    {formattedDate(group.party.createdAt, true)}
                  </p>
                </div>
              </div>
              <div className=" text-center row  mt-2 agesGroup">
                <span className="d-flex fw-semibold col-auto">Ages:&nbsp;</span>
                <span className="d-flex yellowTxt col-auto p-0 ageP gap-1">
                  {group.invitations.map((invitation) => <span className="badge text-bg-dark">{invitation.age}</span>)}
                </span>
              </div>
              <div
                className="yellowTxt d-flex carousel-container"
                onScroll={handleScroll}
                onMouseDown={handleDragStart}
                onTouchStart={handleDragStart}
              >
                <div className="carousel-seen d-flex d-flex-wrap">
                  {group.invitations.map((invitation) => (
                    <Link
                      to={routes.PromGroupDetailPage(group.party.city, group.party.id)}
                      key={group.party.id}
                      onClick={() => handleClickInvitation(group)}
                    >
                      <img key={invitation.id} 
                        src={getUserAvatar(invitation?.id!)} 
                        alt={(invitation?.firstName ?? 'Profile Photo')} 
                        className="m-2 imgGuest"
                        onError={(event) => handleImgError(event, invitation.gender.toString())} />
                    </Link>
                  ))}
                </div>
              </div>
              <div className="mt-2 row">
                <span className="d-flex fw-semibold col-auto">Requested:&nbsp;</span>
                <span className="d-flex col-auto yellowTxt p-0 ageP gap-1">                  
                  {group.requestedListings.map((listing) => <span className="badge text-bg-dark">{listing.clubName}</span>)}
                </span>
              </div>
              {group.promotersOffers.length > 0 ?
                <div className="mt-2 row">
                  <span className="d-flex fw-semibold col-auto">Sent:&nbsp;</span>
                  <span className="d-flex col-auto yellowTxt p-0 ageP gap-1">
                    {group.promotersOffers.map((listing) => listing.offers.map((offer) => <span className="badge text-bg-dark">{offer.clubName}</span>))}
                  </span>
                </div> : ""
              }
            </div>
          ))}
        </div>
      ) : requestState === 'loading' ? null : (
        <div className="container newTabContent">
          <p>
            {filteredGroupsBySeen.length === 0
              ? "Here you will find the groups you have already seen."
              : hasActiveMinimumAgeFilter
                ? "No seen groups match the selected minimum age."
                : "No seen groups available."}
          </p>
        </div>
      )}
    </>
  );
};

export default Seen;
